import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/common/inputs/select/select';
import { useI18n } from '@/locales/client';

export interface Language {
  key: string;
  name: string;
}

interface LanguageSelectorProps {
  onSelectLanguage: (language: Language) => void;
  selectedLanguage: Language | null;
  className?: string;
}

export const LanguageSelector = ({
  onSelectLanguage,
  selectedLanguage,
  className,
}: LanguageSelectorProps) => {
  const t = useI18n();

  const languages: Language[] = [
    { key: 'fr', name: t('register.languages.fr') },
    { key: 'en', name: t('register.languages.en') },
  ];

  return (
    <Select
      onValueChange={(value) => {
        const language = languages.find((lang) => lang.key === value);
        if (language) {
          onSelectLanguage(language);
        }
      }}
      value={selectedLanguage?.key || ''}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={t('register.langSelect')} />
      </SelectTrigger>
      <SelectContent>
        {languages.map((language) => (
          <SelectItem key={language.key} value={language.key}>
            {language.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
